<div class="k-overlay" *ngIf="editFormActive"></div>
<kendo-window *ngIf="editFormActive" (close)="closeEditForm()" [width]="1300" (keydown)="modalKeyDown($event)"
  style="position:fixed" [top]="30">
  <kendo-window-titlebar>
    <div class="k-window-title">
      <h3>{{ ( (isNew || isCopy) ? 'ADD-FORM-FIELD' : 'EDIT-FORM-FIELD' ) | translate }}</h3>
    </div>
    <button kendoWindowMaximizeAction></button>
    <button kendoWindowRestoreAction></button>
    <button kendoWindowCloseAction></button>
  </kendo-window-titlebar>
  <form novalidate [formGroup]="editForm">
    <kendo-tabstrip #tabstrip>
      <kendo-tabstrip-tab title="{{ 'FORM-EDIT-TAB-GENERAL' | translate }}" [selected]="true">
        <ng-template kendoTabContent>
          <div class="k-form">
            <div class="row">
              <!--Key-->
              <div class="col-6" *ngIf="!isInputHeader()">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'FORM-KEY' | translate}} *
                  </span>
                  <input #fieldKeyInput id="key" kendoTextBox formControlName="key" (keydown)="validateKey($event)" />
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="editForm.controls.key.hasError('required') && editForm.controls.key.touched">
                    {{'FORM-KEY-REQUIRED' | translate}}
                  </div>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="editForm.controls.key.hasError('pattern') && editForm.controls.key.touched">
                    {{'FORM-KEY-INVALID-PATTERN' | translate}}
                  </div>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="editForm.controls.key.hasError('keyNameExists') && editForm.controls.key.touched">
                    {{'FORM-FIELD-NAME-EXISTS' | translate}}
                  </div>
                </label>
              </div>
              <!--Consent option-->
              <div class="col-6" *ngIf="isRadio() && consentTypeAssessment && consentableDataTypes.length > 0"
                formGroupName="templateOptions">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'CONSENT-MAPPING' | translate}}
                  </span>
                  <kendo-combobox class="w-100" formControlName="consentDictionaryId" [data]="consentableDataTypes"
                    [textField]="'displayName'" [valueField]="'id'" [valuePrimitive]="true">
                  </kendo-combobox>
                </label>
              </div>
              <!--Tab type-->
              <ng-template *ngIf="isLabelText()" [ngTemplateOutlet]="tabTypeControl"> </ng-template>
              <!--Input Type-->
              <div class="col-6" *ngIf="isInput() && !isInputHeader()" formGroupName="templateOptions">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'INPUT-TYPE' | translate}} *
                  </span>
                  <kendo-combobox id="type" formControlName="type" class="w-100" [valuePrimitive]="true"
                    [data]="inputTypes" [textField]="'text'" [valueField]="'id'">
                  </kendo-combobox>
                  <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="editForm.controls.templateOptions.controls.type.hasError('required') && 
                          editForm.controls.templateOptions.controls.type.touched">
                    {{'REQUIRED-INPUT-TYPE' | translate}}
                  </div>
                </label>
              </div>
            </div>
            <div formGroupName="templateOptions">
              <!--Label-->
              <div class="row" *ngIf="!isTab() && !isLabelText()">
                <div [ngClass]="{'col-12': availableTabs.length === 0, 'col-6': availableTabs.length > 0}">
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                      {{'FORM-LABEL' | translate}} *
                    </span>
                    <input id="label" kendoTextBox formControlName="label" />
                    <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="editForm.controls.templateOptions.controls.label.hasError('required') && 
                             editForm.controls.templateOptions.controls.label.touched">
                      {{'FORM-LABEL-REQUIRED' | translate}}
                    </div>
                  </label>
                </div>
                <!--Tab type-->
                <ng-template [ngTemplateOutlet]="tabTypeControl"> </ng-template>
              </div>
              <!--Placeholder-->
              <div class="row" *ngIf="showPlaceholder()">
                <div class="col-12">
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                      {{'FORM-PLACEHOLDER' | translate}}
                    </span>
                    <input id="placeholder" kendoTextBox formControlName="placeholder" />
                  </label>
                </div>
              </div>
              <!--Dictionary if this is a select-->
              <div class="row" *ngIf="isSelect()">
                <div class="col-6">
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                      {{'CODE-SET' | translate}}
                    </span>
                    <kendo-combobox class="w-100" formControlName="codeSetId" [data]="codeSets" [textField]="'name'"
                      [valueField]="'id'" [valuePrimitive]="true">
                    </kendo-combobox>
                  </label>
                </div>
              </div>
              <div class="row" *ngIf="!isInputHeader() && !isLabelText() && !isTab()">
                <!--Patient Extensions-->
                <div class="col-6">
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                      {{'SAVE-VALUE-PATIENT-EXTENSION' | translate:patientLabel}}
                    </span>
                    <kendo-combobox class="w-100" formControlName="savePatientExtensionId" [data]="patientExtensions"
                      [textField]="'name'" [valueField]="'id'" [valuePrimitive]="true">
                    </kendo-combobox>
                  </label>
                </div>
                <!--Case Extensions-->
                <div class="col-6">
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                      {{'SAVE-VALUE-CASE-EXTENSION' | translate}}
                    </span>
                    <kendo-combobox class="w-100" formControlName="saveCaseExtensionId" [data]="caseExtensions"
                      [textField]="'name'" [valueField]="'id'" [valuePrimitive]="true">
                    </kendo-combobox>
                  </label>
                </div>
              </div>
              <!--Description-->
              <div class="row" *ngIf="!isInputHeader() && !isTab() && !isLabelText()">
                <div class="col-12">
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                      {{'FORM-DESCRIPTION' | translate}}
                    </span>
                    <textarea id="description" kendoTextArea class="w-100 k-textarea" rows="3"
                      formControlName="description" style="min-height: 38px;">
                    </textarea>
                  </label>
                </div>
              </div>
              <!--Text Label-->
              <div class="row" *ngIf="isLabelText()">
                <div class="col-12 mt-2">
                  <kendo-editor class="assessment-html-editor" [iframe]="false" formControlName="description"
                    [updateInterval]="1000" (valueChange)="labelChange()" style="min-height:60vh">
                    <kendo-toolbar>
                      <kendo-toolbar-buttongroup>
                        <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
                        <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
                        <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
                        <kendo-toolbar-button kendoEditorStrikethroughButton></kendo-toolbar-button>
                      </kendo-toolbar-buttongroup>
                      <kendo-toolbar-buttongroup>
                        <kendo-toolbar-button kendoEditorSubscriptButton></kendo-toolbar-button>
                        <kendo-toolbar-button kendoEditorSuperscriptButton></kendo-toolbar-button>
                      </kendo-toolbar-buttongroup>
                      <kendo-toolbar-buttongroup>
                        <kendo-toolbar-button kendoEditorAlignLeftButton></kendo-toolbar-button>
                        <kendo-toolbar-button kendoEditorAlignCenterButton></kendo-toolbar-button>
                        <kendo-toolbar-button kendoEditorAlignRightButton></kendo-toolbar-button>
                        <kendo-toolbar-button kendoEditorAlignJustifyButton></kendo-toolbar-button>
                      </kendo-toolbar-buttongroup>
                      <kendo-toolbar-dropdownlist kendoEditorFormat></kendo-toolbar-dropdownlist>
                      <kendo-toolbar-dropdownlist kendoEditorFontSize></kendo-toolbar-dropdownlist>
                      <kendo-toolbar-dropdownlist kendoEditorFontFamily></kendo-toolbar-dropdownlist>
                      <kendo-toolbar-colorpicker kendoEditorForeColor view="gradient"></kendo-toolbar-colorpicker>
                      <kendo-toolbar-colorpicker kendoEditorBackColor view="gradient"></kendo-toolbar-colorpicker>
                      <kendo-toolbar-buttongroup>
                        <kendo-toolbar-button kendoEditorInsertUnorderedListButton></kendo-toolbar-button>
                        <kendo-toolbar-button kendoEditorInsertOrderedListButton></kendo-toolbar-button>
                        <kendo-toolbar-button kendoEditorIndentButton></kendo-toolbar-button>
                        <kendo-toolbar-button kendoEditorOutdentButton></kendo-toolbar-button>
                      </kendo-toolbar-buttongroup>
                      <kendo-toolbar-button kendoEditorBlockquoteButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorSelectAllButton></kendo-toolbar-button>
                      <kendo-toolbar-buttongroup>
                        <kendo-toolbar-button kendoEditorUndoButton></kendo-toolbar-button>
                        <kendo-toolbar-button kendoEditorRedoButton></kendo-toolbar-button>
                      </kendo-toolbar-buttongroup>
                      <kendo-toolbar-buttongroup>
                        <kendo-toolbar-button kendoEditorCreateLinkButton></kendo-toolbar-button>
                        <kendo-toolbar-button kendoEditorUnlinkButton></kendo-toolbar-button>
                      </kendo-toolbar-buttongroup>
                      <kendo-toolbar-button kendoEditorInsertImageButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorViewSourceButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorCleanFormattingButton></kendo-toolbar-button>
                      <kendo-editor-insert-table-button></kendo-editor-insert-table-button>
                      <kendo-toolbar-buttongroup>
                        <kendo-toolbar-button kendoEditorAddColumnBeforeButton></kendo-toolbar-button>
                        <kendo-toolbar-button kendoEditorAddColumnAfterButton></kendo-toolbar-button>
                        <kendo-toolbar-button kendoEditorAddRowBeforeButton></kendo-toolbar-button>
                        <kendo-toolbar-button kendoEditorAddRowAfterButton></kendo-toolbar-button>
                      </kendo-toolbar-buttongroup>
                      <kendo-toolbar-buttongroup>
                        <kendo-toolbar-button kendoEditorDeleteColumnButton></kendo-toolbar-button>
                        <kendo-toolbar-button kendoEditorDeleteRowButton></kendo-toolbar-button>
                        <kendo-toolbar-button kendoEditorDeleteTableButton></kendo-toolbar-button>
                      </kendo-toolbar-buttongroup>
                      <kendo-toolbar-buttongroup>
                        <kendo-toolbar-button kendoEditorMergeCellsButton></kendo-toolbar-button>
                        <kendo-toolbar-button kendoEditorSplitCellButton></kendo-toolbar-button>
                      </kendo-toolbar-buttongroup>
                    </kendo-toolbar>
                  </kendo-editor>
                </div>
              </div>
              <!--Default to Today-->
              <div *ngIf="isDate() || isDateTime()">
                <input id="defaultToday" type="checkbox" formControlName="defaultToday"
                  [checked]="editForm.controls.templateOptions.controls.defaultToday.value" kendoCheckBox />
                <label class="k-checkbox-label k-text-uppercase dark" for="defaultToday">{{ 'DEFAULT-TO-TODAY' |
                  translate
                  }}
                </label>
              </div>
              <!--Required-->
              <div *ngIf="!isInputHeader() && !isTab() && !isLabelText()">
                <input id="required" type="checkbox" formControlName="required"
                  [checked]="editForm.controls.templateOptions.controls.required.value" kendoCheckBox />
                <label class="k-checkbox-label k-text-uppercase dark" for="required">{{ 'FIELD-REQUIRED' | translate }}
                </label>
              </div>
            </div>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab title="{{ (isTab() ? 'TABS' : 'FORM-EDIT-TAB-OPTIONS') | translate }}"
        *ngIf="isInputAsOptions()">
        <ng-template kendoTabContent>
          <div [formGroup]="editForm" class="k-form" style="max-height: 495px;">
            <button kendoButton [primary]="true" (click)="addOption()" type="button" class="mb-2">
              {{'ADD-VALUE' | translate}}<i class="far fa-plus"></i>
            </button>
            <div class="k-tooltip k-tooltip-validation" role="alert" [hidden]="hiddenOptionRequired">{{ 'NO-VALUE' |
              translate }}
            </div>
            <div formGroupName="templateOptions" class="container-options">
              <table class="table mb-0">
                <thead>
                  <tr>
                    <th>
                      <label class="control-label k-text-uppercase dark font-weight-normal">{{ 'NAME' | translate }}
                        *</label>
                    </th>
                    <th>
                      <label class="control-label k-text-uppercase dark font-weight-normal">{{ 'VALUE' | translate }}
                        *</label>
                    </th>
                    <th *ngIf="!isTab()">
                      <label class="control-label k-text-uppercase dark font-weight-normal">{{ 'EXTERNAL-ID' | translate
                        }}
                      </label>
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let option of editForm.controls.templateOptions.controls.options.controls; let i=index"
                    formArrayName="options">
                    <td style="width:45%" [formGroupName]="i">
                      <input kendoTextBox formControlName="label" class="w-100" maxlength="255"
                        (blur)="optionNameChanged($event, i)" />
                      <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="editForm.controls.templateOptions.controls.options.controls[i].controls.label.hasError('required') && 
                               editForm.controls.templateOptions.controls.options.controls[i].controls.label.touched">
                        {{ 'REQUIRED-NAME' | translate }}
                      </div>
                    </td>
                    <td style="width:100%" [formGroupName]="i" class="pr-0">
                      <!--Revert changed from control below : (paste)="onPaste($event, i)" -->
                      <input kendoTextBox formControlName="value" class="w-100" maxlength="100"
                        (keydown)="validateValue($event, i)" />
                      <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="editForm.controls.templateOptions.controls.options.controls[i].controls.value.hasError('required') &&
                               editForm.controls.templateOptions.controls.options.controls[i].controls.value.touched">
                        {{ 'REQUIRED-FIELD-VALUE' | translate }}
                      </div>
                    </td>
                    <td style="width:20%" [formGroupName]="i" *ngIf="!isTab()">
                      <input kendoTextBox formControlName="externalId" class="w-100" maxlength="50" />
                    </td>
                    <td [formGroupName]="i" style="min-width:120px;max-width:120px;">
                      <div class="row m-0 p-0">
                        <div style="width:30px">
                          <a title="{{ 'DELETE' | translate }}" (click)="removeOption(i)">
                            <i class="fas fa-fw fa-times-circle fa-delete-custom">&nbsp;</i>
                          </a>
                        </div>
                        <div style="width:30px" *ngIf="i > 0" (click)="changeTabOrder(i,'up')">
                          <i title="{{'MOVE-UP'|translate}}" class="fa fa-arrow-circle-up pointer fa-delete-custom">
                          </i>
                        </div>
                        <div style="width:30px"
                          *ngIf="editForm.controls.templateOptions.controls.options.controls.length-1 > i"
                          (click)="changeTabOrder(i,'down')">
                          <i title="{{'MOVE-DOWN'|translate}}" class="fa fa-arrow-circle-down pointer fa-delete-custom"
                            [ngClass]="{'extra-button-space': i === 0}">
                          </i>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab title="{{ 'FORM-EDIT-TAB-ADVANCED' | translate }}" *ngIf="!isInputHeader()">
        <ng-template kendoTabContent>
          <div class="k-form">
            <div formGroupName="templateOptions">
              <div *ngIf="isInput()">
                <div class="row" *ngIf="editForm.controls.templateOptions.controls.type.value !== 'number'">
                  <!--Text minLength-->
                  <div class="col-6">
                    <label class="k-form-field">
                      <span class="k-text-uppercase dark">
                        {{'MIN-LENGTH' | translate}}
                      </span>
                      <kendo-numerictextbox [format]="'n0'" formControlName="minLength" class="w-100">
                      </kendo-numerictextbox>
                    </label>
                  </div>
                  <!--Text maxLength-->
                  <div class="col-6">
                    <label class="k-form-field">
                      <span class="k-text-uppercase dark">
                        {{'MAX-LENGTH' | translate}}
                      </span>
                      <kendo-numerictextbox [format]="'n0'" formControlName="maxLength" class="w-100">
                      </kendo-numerictextbox>
                    </label>
                  </div>
                </div>
                <div class="row" *ngIf="editForm.controls.templateOptions.controls.type.value === 'number'">
                  <!--Numeric min-->
                  <div class="col-6">
                    <label class="k-form-field">
                      <span class="k-text-uppercase dark">
                        {{'MIN-VALUE' | translate}}
                      </span>
                      <kendo-numerictextbox [format]="'n0'" formControlName="min" class="w-100"></kendo-numerictextbox>
                    </label>
                  </div>
                  <!--Numeric max-->
                  <div class="col-6">
                    <label class="k-form-field">
                      <span class="k-text-uppercase dark">
                        {{'MAX-VALUE' | translate}}
                      </span>
                      <kendo-numerictextbox [format]="'n0'" formControlName="max" class="w-100"></kendo-numerictextbox>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <!--Disabled expression-->
            <div class="row">
              <div class="col-12">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'FORM-DISABLED-EXPRESSION' | translate}}
                  </span>
                  <textarea id="expressionProperties" kendoTextArea [autoSize]="false" rows="3"
                    formControlName="expressionProperties" class="w-100">
                  </textarea>
                </label>
                <small *ngIf="!isTab()" class="form-text text-muted example-text">{{ 'FORM-EXPRESSION-EXAMPLE' |
                  translate}}&nbsp;!model.Name</small>
                <small *ngIf="isTab()" class="form-text text-muted example-text">{{ 'FORM-EXPRESSION-EXAMPLE' |
                  translate}}&nbsp;!field.parent.model.Name</small>
              </div>
            </div>
            <!--Hide expression-->
            <div class="row">
              <div class="col-12">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'FORM-HIDE-EXPRESSION' | translate}}
                  </span>
                  <textarea id="hideExpression" kendoTextArea [autoSize]="false" rows="3"
                    formControlName="hideExpression" class="w-100">
                  </textarea>
                </label>
                <small class="form-text text-muted example-text">
                  <span *ngIf="!isTab()">!model.MultiCheckbox || !model.MultiCheckbox.Other</span>
                  <span *ngIf="isTab()">!field.parent.model.tabVisibility ||
                    field.parent.model.tabVisibility=='No'</span>
                </small>
              </div>
            </div>
            <!--Class Name-->
            <div class="row" formGroupName="templateOptions">
              <div class="col-3">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'FIELD-CLASSNAME-WIDTH' | translate}}
                  </span>
                </label>
                <input type="radio" value="w-25" name="className" id="radio25" (click)="setClassName('w-25')"
                  formControlName="className" kendoRadioButton />
                <label class="k-radio-label custom-radio-width mr-2" for="radio25">25%</label>
                <input type="radio" value="w-50" name="className" id="radio50" (click)="setClassName('w-50')"
                  formControlName="className" kendoRadioButton />
                <label class="k-radio-label custom-radio-width mr-2" for="radio50">50%</label>
                <input type="radio" value="w-75" name="className" id="radio75" (click)="setClassName('w-75')"
                  formControlName="className" kendoRadioButton />
                <label class="k-radio-label custom-radio-width mr-2" for="radio75">75%</label>
                <input type="radio" value="w-100" name="className" id="radio100" (click)="setClassName('w-100')"
                  formControlName="className" kendoRadioButton />
                <label class="k-radio-label custom-radio-width mr-2" for="radio100">100%</label>
              </div>
              <div class="col-3">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'FIELD-CLASSNAME' | translate}}
                  </span>
                  <input id="classname" kendoTextBox formControlName="className" />
                </label>
              </div>
              <div class="col-3" *ngIf="!isTab() && !isLabelText()">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'EXTERNAL-ID' | translate}}
                  </span>
                  <input id="classname" kendoTextBox formControlName="externalId" maxlength="50" />
                </label>
              </div>
              <div class="col-3" *ngIf="isRadio()">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'SUM-CONTROL-NAME' | translate}}
                  </span>
                  <input id="sumKey" kendoTextBox formControlName="sumKey" />
                </label>
              </div>
            </div>
            <!--Field Horizontal Layout-->
            <div *ngIf="!isInputHeader() && !isTab() && !isLabelText()">
              <input id="isFormFieldHorizontal" type="checkbox" formControlName="isFormFieldHorizontal"
                [checked]="editForm.controls.isFormFieldHorizontal.value" kendoCheckBox />
              <label class="k-checkbox-label k-text-uppercase dark" for="isFormFieldHorizontal">{{
                'FORM-FIELD-HORIZONTAL' | translate }}
              </label>
            </div>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
    </kendo-tabstrip>
  </form>
  <div class="mt-3">* {{'REQUIRED-FIELDS' | translate}}</div>
  <kendo-dialog-actions style="height:58px">
    <button class="k-button" (click)="onCancel($event)">{{ 'CANCEL' | translate }}</button>
    <button appPreventClick class="k-button k-primary" [disabled]="!editForm.valid || !editForm.dirty"
      (click)="onApply($event)" style="margin-right:-14px">{{ 'APPLY' | translate }}
    </button>
  </kendo-dialog-actions>
</kendo-window>

<!--Tab type template-->
<ng-template #tabTypeControl>
  <div class="col-6" *ngIf="availableTabs.length > 0" [formGroup]="editForm">
    <label class="k-form-field">
      <span class="k-text-uppercase dark">
        {{'TAB' | translate}}
      </span>
      <kendo-combobox id="tab" formControlName="tab" class="w-100" [valuePrimitive]="true" [data]="availableTabs"
        [textField]="'text'" [valueField]="'id'">
      </kendo-combobox>
    </label>
  </div>
</ng-template>